import React from 'react';
import useSearcherValidation from 'legacyfrontend/hooks/useSearcherValidation';

/**
 * HOC para proteger rutas que requieren searchers específicos habilitados
 * @param {React.Component} WrappedComponent - El componente a proteger
 * @returns {React.Component} - Componente protegido con validación
 */
const withSearcherValidation = (WrappedComponent) => {
  const WithSearcherValidationComponent = (props) => {
    useSearcherValidation();

    return <WrappedComponent {...props} />;
  };

  WithSearcherValidationComponent.displayName = `withSearcherValidation(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithSearcherValidationComponent;
};

export default withSearcherValidation;
